"use_strict"

class MobileMenu {
	constructor () {
		this._menuToggle = document.querySelector('.menu-toggle');

		if ( !this._menuToggle ) return;

		this._bindUIActions();
	}

	/**
	 * @function _bindUIActions
	 * @desc Add event listener to the newsletter form's field
	 */
	_bindUIActions () {
		this._menuToggle.addEventListener( 'click', function () {
			if ( document.body.classList.contains( 'menu-opened' ) ) {
				document.body.classList.remove( 'menu-opened' );
			} else {
				document.body.classList.add( 'menu-opened' );
			}
		});
	}
}

export { MobileMenu }
